// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"NY-z","inlineTitle":"OY-z","sponsoredAdsWrapper":"PY-z","marketplaceRecosWrapper":"QY-z"};